import { useCallback } from 'react';

//services
import { postNotes } from 'services/notes';

//icons
import CloseSvg from '../../assets/md-close.svg';
import CheckIcon from '../../assets/check_icon.svg';

//recoil
import { useSetRecoilState } from 'recoil';
import { toastState } from 'recoil/ToastAtom';
import { notesStatusAtom } from 'recoil/NotesStatusAtom';

export interface NotesBody {
  note: string | null;
}

export const usePostNote = () => {
  const setToast = useSetRecoilState(toastState);
  const setNotesStatus = useSetRecoilState(notesStatusAtom);

  const handlePostNote = useCallback(
    async (idExcercise: number, body: NotesBody) => {
      try {
        const status = await postNotes(idExcercise, body);

        if (status === 200) {
          setNotesStatus(status);
          setToast({
            isOpen: true,
            color: 'success',
            message: 'Guardaste la nota',
            icon: CheckIcon,
            button: [
              {
                icon: CloseSvg,
                side: 'end',
                role: 'cancel',
                cssClass: 'toast-button',
              },
            ],
          });
        }
      } catch (e) {
        console.log(e, 'error');
      }
    },
    [setToast, setNotesStatus]
  );

  return { handlePostNote };
};
